import { StateRouter as State } from '@/store/state';
import makeSlicer from '@/utils/makeSlicer';

const rootSlicer = makeSlicer<State>();

export const currentUrl = rootSlicer('path');
export const redirectUrl = rootSlicer('redirectUrl');
export const params = rootSlicer('params');
